import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const LockIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <rect x="3" y="10" width="18" height="12" fill={getColor(secondaryColor)} />
      <path
        d="M6.5 6.5L6 9V9.5H9.5V8V6.5L10.5 5L12.5 4.5L14 5.5L14.5 7.5L15 9.5H18V7.5L17.5 5.5L16.5 3.5L15 2.5L13 1.5L10.5 2L8.5 2.5L7 5L6.5 6.5Z"
        fill={getColor(secondaryColor)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.40002 11.4844C2.40002 10.1865 3.45215 9.13437 4.75002 9.13437H19.25C20.5479 9.13437 21.6 10.1865 21.6 11.4844V21.1094C21.6 22.4072 20.5479 23.4594 19.25 23.4594H4.75002C3.45216 23.4594 2.40002 22.4072 2.40002 21.1094V11.4844ZM4.75002 10.8344C4.39104 10.8344 4.10002 11.1254 4.10002 11.4844V21.1094C4.10002 21.4684 4.39104 21.7594 4.75002 21.7594H19.25C19.609 21.7594 19.9 21.4684 19.9 21.1094V11.4844C19.9 11.1254 19.609 10.8344 19.25 10.8344H4.75002Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.40002 7.14062C5.40002 3.49554 8.35494 0.540619 12 0.540619C15.6451 0.540619 18.6 3.49554 18.6 7.14062V10.8344H5.40002V7.14062ZM12 2.24062C9.29383 2.24062 7.10002 4.43442 7.10002 7.14062V9.13437H16.9V7.14062C16.9 4.43442 14.7062 2.24062 12 2.24062Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.36877 7.14062C8.36877 5.13514 9.99454 3.50937 12 3.50937C14.0055 3.50937 15.6313 5.13514 15.6313 7.14062V10.8344H8.36877V7.14062ZM12 5.20937C10.9334 5.20937 10.0688 6.07402 10.0688 7.14062V9.13437H13.9313V7.14062C13.9313 6.07402 13.0666 5.20937 12 5.20937Z"
        fill="currentColor"
      />
      <path
        d="M6.84375 12.6094C6.84375 13.1789 6.38204 13.6406 5.8125 13.6406C5.24296 13.6406 4.78125 13.1789 4.78125 12.6094C4.78125 12.0398 5.24296 11.5781 5.8125 11.5781C6.38204 11.5781 6.84375 12.0398 6.84375 12.6094Z"
        fill="currentColor"
      />
      <path
        d="M6.84375 19.9844C6.84375 20.5539 6.38204 21.0156 5.8125 21.0156C5.24296 21.0156 4.78125 20.5539 4.78125 19.9844C4.78125 19.4148 5.24296 18.9531 5.8125 18.9531C6.38204 18.9531 6.84375 19.4148 6.84375 19.9844Z"
        fill="currentColor"
      />
      <path
        d="M19.2188 12.6094C19.2188 13.1789 18.757 13.6406 18.1875 13.6406C17.618 13.6406 17.1562 13.1789 17.1562 12.6094C17.1562 12.0398 17.618 11.5781 18.1875 11.5781C18.757 11.5781 19.2188 12.0398 19.2188 12.6094Z"
        fill="currentColor"
      />
      <path
        d="M19.2188 19.9844C19.2188 20.5539 18.757 21.0156 18.1875 21.0156C17.618 21.0156 17.1562 20.5539 17.1562 19.9844C17.1562 19.4148 17.618 18.9531 18.1875 18.9531C18.757 18.9531 19.2188 19.4148 19.2188 19.9844Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 14.8969C11.2268 14.8969 10.6 15.5237 10.6 16.2969C10.6 17.0701 11.2268 17.6969 12 17.6969C12.7732 17.6969 13.4 17.0701 13.4 16.2969C13.4 15.5237 12.7732 14.8969 12 14.8969ZM8.90002 16.2969C8.90002 14.5848 10.2879 13.1969 12 13.1969C13.7121 13.1969 15.1 14.5848 15.1 16.2969C15.1 18.009 13.7121 19.3969 12 19.3969C10.2879 19.3969 8.90002 18.009 8.90002 16.2969Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default LockIconFilled;
